import axios from 'axios';
import envStore from './model';

export function getDevices() {
    return axios.get('/zhgd/envTab/deviceInfo?pageSize=1000&pageNo=1')
        .then((data) => {
            envStore.setDevices(data.result);
            return data.result;
        })
        .catch((e) => console.log(e));
}

export function getInfo(id) {
    return axios.get(`/zhgd/envTab/deviceArgsInfo?pageSize=1000&pageNo=1&deviceId=${id}`)
        .then((data) => {
            envStore.setInfo(data.result || []);
        })
        .catch((e) => console.log(e));
}
